/**
 * Settings for the secured-card design prototype.
 * 5% APY matches a high-yield rate in the market (Chime pays 5%) and is a
 * savings yield this card could offer.
 * 2% cashback is a typical flat unlimited cash-back rate (the level of
 * Citi Double Cash and Wells Fargo Active Cash). It is not a rewards offer.
 * 80% of each payroll deposit becomes spending power. The rest stays saved.
 */

export const CARD_LAST4 = '4242';

export const SAVINGS_APY_PERCENT = 5;

export const SAVINGS_APY_LABEL = '5% APY';

export const CASHBACK_PERCENT = 2;

export const CASHBACK_LABEL = '2% cashback';

/** Share of savings the card can spend. $500 from payroll makes $400 available. */
export const SPENDABLE_PERCENT = 80;

export const DEFAULT_PAYCHECK_CENTS = 50_000;

export const DEFAULT_PAYCHECK_COUNT = 4;

export const MAX_PAYCHECKS = 6;

export const PAYCHECK_MIN_CENTS = 5_000;

export const PAYCHECK_MAX_CENTS = 200_000;

export const PAYCHECK_STEP_CENTS = 2_500;

export const PAYCHECK_PRESETS_CENTS = [25_000, 50_000, 75_000, 100_000] as const;

export const PAYCHECK_COUNT_PRESETS = [1, 2, 4, 6] as const;

/** Everyday purchase used once the line exists. Capped to whatever is available. */
export const SAMPLE_PURCHASE_CENTS = 12_000;

export const SAMPLE_PURCHASE = {
  merchant: 'Grocery run',
  detail: 'Everyday spending',
} as const;

/** First sample payday: Friday, October 2, 2026. */
export const FIRST_PAY_YEAR = 2026;

export const FIRST_PAY_MONTH_INDEX = 9;

export const FIRST_PAY_DAY = 2;

export const PROTOTYPE_PREFIX = '/prototypes/secured-card';
